import React, { useState } from "react";
import {
  FaHome,
  FaList,
  FaBookmark,
  FaChartLine,
  FaUser,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import "./Header.css";
import logo from '../Images/logo.png';
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  // const menuItems = [
  //   { name: "Home", icon: <FaHome /> },
  //   { name: "Categories", icon: <FaList /> },
  //   { name: "Saved", icon: <FaBookmark /> },
  //   { name: "Investment", icon: <FaChartLine /> },
  //   { name: "Profile", icon: <FaUser /> },
  // ];
  const menuItems = [
    { name: "Home", icon: <FaHome />, path: "/homee" },
    { name: "Categories", icon: <FaList />, path: "/categories" },
    { name: "Saved", icon: <FaBookmark />, path: "/saved" },
    { name: "Investment", icon: <FaChartLine />, path: "/bookings_Investor" },
    { name: "Profile", icon: <FaUser />, path: "/profile" },
  ];

   const handleNavigate = (path) => {
    navigate(path);
    setOpen(false);
  };
  return (
    <>
      {/* HEADER */}
      <header className="header">
        {/* <div className="logo">
          <span>💠</span> MyApp
        </div> */}
         <div className="logo1">
                  <img src={logo} alt="Property Galleria" className="logo-img" />
                </div>

        <nav className="nav">
          {menuItems.map((item, index) => (
            <a key={index}    onClick={() => handleNavigate(item.path)} >
              {item.icon}
              <span>{item.name}</span>
            </a>
          ))}
        </nav>

        <div className="menu-icon" onClick={() => setOpen(true)}>
          <FaBars />
        </div>
      </header>

      {/* MOBILE SIDEBAR */}
      <div className={`sidebar ${open ? "active" : ""}`}>
        <div className="close-icon" onClick={() => setOpen(false)}>
          <FaTimes />
        </div>

        {menuItems.map((item, index) => (
          <a key={index}   onClick={() =>{ handleNavigate(item.path); setOpen(false)}}>
            {item.icon}
            <span>{item.name}</span>
          </a>
        ))}
      </div>

      {/* OVERLAY */}
      {open && <div className="overlay" onClick={() => setOpen(false)}></div>}
    </>
  );
};

export default Header;
